import { render, staticRenderFns } from "./LegalTb.vue?vue&type=template&id=ee3c631a&scoped=true&"
import script from "./LegalTb.vue?vue&type=script&lang=js&"
export * from "./LegalTb.vue?vue&type=script&lang=js&"
import style0 from "./LegalTb.vue?vue&type=style&index=0&id=ee3c631a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3c631a",
  null
  
)

export default component.exports